export default __webpack_public_path__ + "static/media/qrcode.5bb50c21.png";